import s from './Spinner.module.scss'

type PropsType = {
  color?: string
  size?: number
}

export const Spinner = ({ color = 'var(--corp)', size = 32 }: PropsType) => {
  return (
    <div
      className={s.spinner}
      style={{ borderRightColor: color, borderBottomColor: color, width: `${size}px`, height: `${size}px` }}
    />
  )
}
